import {
  AfterViewInit,
  ChangeDetectionStrategy,
  Component,
  Input,
  OnChanges,
  OnDestroy,
  TemplateRef,
  ViewChild
} from '@angular/core';

import { Subject, filter, takeUntil } from 'rxjs';

import { MetaMenuType, UserAccountData } from '@hdms/shared/page-frame/types';
import { FlyoutDirective } from '@hdms/shared/ui-core';
import { AnalyticsService, SlideInOutDimension, slideInOut } from '@hdms/shared/util-core';

import { TrackingValue } from '../../../config/header.const';
import { MenuStateService } from '../../../services';

@Component({
  selector: 'shrd-pf-ft-user-popover',
  templateUrl: './header-user-popover.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  animations: [slideInOut('labelSlide', SlideInOutDimension.WIDTH, 0.1)]
})
export class HeaderUserPopoverComponent implements AfterViewInit, OnChanges, OnDestroy {
  private static labelAnimated = false;

  animateLabel = false;

  @Input() userData: UserAccountData;
  @Input() contentRef: TemplateRef<Element>;

  @ViewChild(FlyoutDirective) private readonly flyout: FlyoutDirective;

  private readonly unsubscribe$ = new Subject<void>();

  constructor(
    private readonly stateService: MenuStateService<MetaMenuType>,
    private readonly analyticsService: AnalyticsService
  ) {}

  ngAfterViewInit(): void {
    this.stateService.close$.pipe(takeUntil(this.unsubscribe$)).subscribe(_ => this.flyout.close());
    this.stateService.currentMenuId$
      .pipe(
        filter(id => id === MetaMenuType.USER_ACCOUNT),
        takeUntil(this.unsubscribe$)
      )
      .subscribe(() => this.flyout.open());
  }

  ngOnChanges(): void {
    // animate username only the first time after userData is loaded
    this.animateLabel = !HeaderUserPopoverComponent.labelAnimated && !this.userData.isLoading;
    HeaderUserPopoverComponent.labelAnimated ||= this.animateLabel;
  }

  ngOnDestroy(): void {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
  }

  handleFlyoutVisibilityChange(isOpened: boolean): void {
    this.analyticsService.sendEvent({
      category: TrackingValue.SITE_OPERATIONS,
      action: 'UserAccountFlyout',
      label: isOpened ? 'Open' : 'Close|Main'
    });
  }
}
